import {
  FETCHING_PAGES_DATA,
  FETCHING_PAGES_DATA_SUCCESS,
  FETCHING_PAGES_DATA_FAILURE,
} from "../constants/actionTypes.js";
//import {API_URL} from "../constants/endpoints";
import api from "../api/pages";

export const requestHomePage = (data) => {
  return async (dispatch) => {
    dispatch(getData(data));
    try {
      const [response, json] = await api("requestHomePage", data);
      json.statusCode = response.status;
      return dispatch(getDataSuccess(json));
    } catch (err) {
      console.log(err);
      return getDataFailure();
    }
  };
};

export const requestStep0Page = (data) => {
  return async (dispatch) => {
    dispatch(getData(data));
    try {
      const [response, json] = await api("requestStep0Page", data);
      json.statusCode = response.status;
      return dispatch(getDataSuccess(json));
    } catch (err) {
      console.log(err);
      return getDataFailure();
    }
  };
};

export const requestStep1Page = (data) => {
  return async (dispatch) => {
    dispatch(getData(data));
    try {
      const [response, json] = await api("requestStep1Page", data);
      json.statusCode = response.status;
      return dispatch(getDataSuccess(json));
    } catch (err) {
      console.log(err);
      return getDataFailure();
    }
  };
};

export const requestStep3Page = (data) => {
  return async (dispatch) => {
    dispatch(getData(data));
    try {
      const [response, json] = await api("requestStep3Page", data);
      json.statusCode = response.status;
      return dispatch(getDataSuccess(json));
    } catch (err) {
      console.log(err);
      return getDataFailure();
    }
  };
};

//API Requests
const getData = (data) => {
  return {
    type: FETCHING_PAGES_DATA,
    payload: data,
    /*meta:{
            offline: {
                effect:   { url: `${API_URL}pages/?type=home.HomePage&fields=*`, method: 'GET' },
                commit:   { type: 'FETCHING_PAGES_DATA_SUCCESS', meta: { data } },
                rollback: { type: 'FETCHING_PAGES_DATA_FAILURE', meta: { data } }
            }
        }*/
  };
};
const getDataSuccess = (data) => {
  return {
    type: FETCHING_PAGES_DATA_SUCCESS,
    data,
  };
};
const getDataFailure = () => {
  return {
    type: FETCHING_PAGES_DATA_FAILURE,
  };
};
